// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1r9Gv","label":"styles_label__3Tydz"};